import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import type { Evidence } from "../../../schemas/finance";
import { queryKeys } from "../../query-keys";

export function useBadgePricing(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.badges.pricing(clubId ?? ""),
		queryFn: () => financeApi.badges.getPricing(clubId!),
		enabled: !!clubId,
	});
}

export function useBadgeStatus(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.badges.status(clubId ?? ""),
		queryFn: () => financeApi.badges.getStatus(clubId!),
		enabled: !!clubId,
	});
}

export function useApplyBadge(clubId: string | undefined) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ tier, evidence }: { tier: "blue" | "gold"; evidence: Evidence }) =>
			financeApi.badges.apply(clubId!, { tier, evidence }),
		onSuccess: () => {
			if (clubId) {
				qc.invalidateQueries({
					queryKey: queryKeys.badges.status(clubId),
				});
			}
		},
	});
}

export function useCreateBadgeCheckout(clubId: string | undefined) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: () => financeApi.badges.createCheckout(clubId!),
		onSuccess: () => {
			if (clubId) {
				qc.invalidateQueries({
					queryKey: queryKeys.badges.status(clubId),
				});
			}
		},
	});
}
